import {
  Box,
  Center,
  Divider,
  Spinner,
  Stack,
  StackDivider,
} from '@chakra-ui/react';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import { MemberCompanyDirectory_Search_memberCompanyDirectorySearch_results } from '../../hooks/graphql-types/MemberCompanyDirectory_Search';
import { MemberCompanyDirectoryHit } from '../MemberCompanyDirectoryHit';

export const Hits: React.FC<{
  companies: MemberCompanyDirectory_Search_memberCompanyDirectorySearch_results[];
  loading: boolean;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}> = ({ companies, loading, hasMore, isLoadingMore, onLoadMore }) => {
  const sentinelRef = React.useRef<HTMLDivElement | null>(null);
  const isLoadingMoreRef = React.useRef(false);

  React.useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel || !hasMore || !onLoadMore) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          !entry.isIntersecting ||
          isLoadingMoreRef.current ||
          isLoadingMore
        ) {
          return;
        }

        isLoadingMoreRef.current = true;
        onLoadMore();
      },
      {
        rootMargin: '250px',
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [hasMore, isLoadingMore, onLoadMore]);

  React.useEffect(() => {
    if (!isLoadingMore) {
      isLoadingMoreRef.current = false;
    }
  }, [isLoadingMore, companies.length]);

  if (loading && companies.length === 0) {
    return <Loading />;
  }

  return (
    <>
      {!!companies.length && <Divider my="4" />}
      <Stack spacing="6" divider={<StackDivider />}>
        {companies.map((company) => (
          <MemberCompanyDirectoryHit key={company._id} company={company} />
        ))}
      </Stack>

      {hasMore && <Box ref={sentinelRef} minH="1px" />}

      {hasMore && isLoadingMore && (
        <Center py="6">
          <Spinner />
        </Center>
      )}
    </>
  );
};
